import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getOrdersList } from '../http/orders';
import { OrderDto } from 'desk-common';

export const useOrders = (
  filters: Partial<OrderDto>,
  options?: Omit<
    UseQueryOptions<
      OrderDto[],
      Error,
      OrderDto[],
      readonly [string, Partial<OrderDto>]
    >,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery({
    queryKey: ['orders', filters],
    queryFn: getOrdersList,
    ...options,
  });
};
